import React, { Component } from 'react';
import { bool, func, object } from 'prop-types';

import { connect } from 'react-redux';

import EsmsDialog from '../../components/EsmsDialog';

import * as ArchitectActions from '../../actions/architectActions';
import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as ClientActions from '../../actions/clientActions';
import * as SiteActions from '../../actions/siteActions';
import * as UiActions from '../../actions/uiActions';

class DeleteSystemEntityModal extends Component {
    handleDelete = async () => {
        const {
            deleteEquipmentSystem,
            selectedSystem,
            selectedNode,
            selectedSite
        } = this.props;

        let isDeleted;

        if (!this.props.isLoading) {
            this.props.toggleLoading(true);
            isDeleted = await deleteEquipmentSystem(selectedNode.id, selectedSystem.id, selectedSite.id);
        }

        if (isDeleted) this.handleClose();

    }

    handleClose = () => {
        this.props.clearErrors();
        this.props.toggleLoading(false);
        this.props.close();
    }

    getContent = () => {
        const { selectedSystem, selectedNode } = this.props;

        return `Are you sure you want to disassociate System: ${selectedSystem.name} from Equipment: ${selectedNode.name}?`;
    }

    render() {
        const {
            errors,
            isLoading,
            open,
            title
        } = this.props;

        return (
            <EsmsDialog
                errors={errors}
                open={open}
                onClose={this.handleClose}
                onConfirm={this.handleDelete}
                isLoading={isLoading}
                title={title}
                confirmText="Delete"
            >
                <p>
                    {this.getContent()}
                </p>
            </EsmsDialog>
        );
    }
}

DeleteSystemEntityModal.defaultProps = {
    selectedNode:      {},
    selectedEquipment: {}
};

DeleteSystemEntityModal.propTypes = {
    companyInfo:    object,
    close:          func.isRequired,
    open:           bool.isRequired,
    selectedNode:   object,
    selectedSystem: object
};

const mapStateToProps = state => {
    return {
        errors:         state.messages.errors,
        isLoading:      state.ui.isLoading,
        selectedClient: state.client.selectedClient,
        selectedNode:   state.architect.selectedNode,
        selectedSystem: state.architect.selectedSystem,
        selectedSite:   state.site.selectedSite
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...ClientActions,
    ...SiteActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSystemEntityModal);
